import { Button, styled } from "@mui/material";
import { elevation, palette, radius } from "@/theme";

interface StyledButtonProps {
  colorVariant?: "default" | "neutral" | "soft";
}

export const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== "colorVariant",
})<StyledButtonProps>(({ theme, colorVariant = "default" }) => ({
  minWidth: "auto",
  boxShadow: elevation.none,
  ...theme.typography.button,
  borderRadius: radius.sm,
  height: 36,
  paddingInline: theme.spacing(2),
  whiteSpace: "nowrap",
  "&.MuiButton-contained, &.MuiButton-outlined": {
    boxShadow: elevation.raised,
  },
  "&.MuiButton-outlined": {
    border: "2px solid",
    backgroundColor: theme.palette.background.default,
    ...(colorVariant === "neutral" && {
      color: theme.palette.neutral[60],
      borderColor: theme.palette.neutral[60],
    }),
    ...(colorVariant === "soft" && {
      border: "none",
      backgroundColor: theme.palette.neutral[10],
      boxShadow: elevation.none,
    }),
    "&:hover": {
      // A light tint of the brand rather than a grey shift.
      backgroundColor:
        colorVariant === "soft"
          ? theme.palette.neutral[20]
          : palette.primary[50],
      ...(colorVariant === "neutral" && {
        borderColor: theme.palette.neutral[70],
      }),
      ...(colorVariant === "soft" && {
        border: "none",
      }),
    },
    /* A destructive button keeps its own colour under the pointer: a brand
       tint behind a red label read as a different, safe action. */
    "&.MuiButton-colorError:hover": {
      backgroundColor: palette.errorLight,
      borderColor: palette.error,
    },
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.neutral[20],
    color: theme.palette.neutral[0],
    borderWidth: 0,
    boxShadow: elevation.none,
  },
  [theme.breakpoints.down("compact")]: {
    paddingInline: theme.spacing(1),
  },
}));
